import { render, staticRenderFns } from "./FundingDetailsDownloads.vue?vue&type=template&id=10aba910&"
import script from "./FundingDetailsDownloads.vue?vue&type=script&lang=js&"
export * from "./FundingDetailsDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports